import apiService from "@/http/apiService";
// import router from "@/router";

const dataModules = {
    namespaced: true,

    state:{
        logIn: null,
        announcements: null,
        getAnnouncement:null,
        feedback:null,
    },

    mutations:{

        setLogIn(state,data){
            state.logIn = data
        },

        // setAnnouncement
        setAnnouncement(state, data){
            state.announcements = data
        },

        setGetAnnouncement(state, data){
            state.getAnnouncement = data
        },

        setFeedback(state, data){
            state.feedback = data
        }
    },

    actions:{

          // logIn
          async logIn({commit}, data){
            try {
                const response = await apiService.logIn(data);
                commit("setLogIn",response.data)

                if(response.status === 200){

                    // console.log("succesful");

                    // if(data.email == "name11@name.com" && data.password == "password"){
                    //     router.push({ name: "Feedback" });
                    // }
                    return response;
                } 
            } catch (error) {
                console.log("logIn error: ",error)
            }
        },

        // createAnnouncement
        async createAnnouncement({commit}, data){
            try {
                const response = await apiService.createAnnouncement(data);
                commit("setAnnouncement",response.data)
                console.log(response.data)

                if(response.status === 200){
                    return response;
                }
                
            } catch (error) {
                console.log("createAnnouncement error: ",error)
            }
        },

         // updateAnnouncement
         async updateAnnouncement({commit}, data){
            try {
                const response = await apiService.updateAnnouncement(data);
                commit("setAnnouncement",response.data)

                if(response.status === 200){
                    return response;
                }
                
            } catch (error) {
                console.log("updateAnnouncement error: ",error)
            }
        },

        // getAnnouncement
        async getAnnouncement({commit}){
            try {
                const response = await apiService.getAnnouncement();
                commit('setGetAnnouncement',response.data[0]);
            } catch (error) {
                console.log('getAnnouncement: ',error)
            }
        },

                // getFeedback
    async getFeedback({commit}){
        try {
            const response = await apiService.getFeedback();
            commit('setFeedback', response.data)
            
        } catch (error) {
            console.log('setFeedback',error)
        }
    },
    },

    getters:{
        getAnnouncement(state){
            return state.getAnnouncement
        },

        // getFeedback
        getFeedback(state){
           return state.feedback;
        }
    },
}

export default dataModules;